import React from "react";
import { Users } from "lucide-react";
import TableBodyCustom from "./table.body-custom";
import DataTable from "../../../../components/data-table/DataTable";

const TABLE_HEAD = [
  { id: "username", label: "Name" },
  { id: "email", label: "Email" },
  { id: "permission", label: "Permission" },
  { id: "status", label: "Status" },
  { id: "action", label: "" },
];

// searching: a search is on, so "empty" means nothing matched.
const TableView = ({ eventsData, onEditRow, searching, }) => (
  <DataTable
    head={TABLE_HEAD}
    isEmpty={!eventsData?.length}
    empty={
      searching
        ? { title: "Nothing matches your search", text: "Try a different word, or clear the search." }
        : {
            icon: Users,
            title: "No team members yet",
            text: "Add the people who help run your masjid's account.",
          }
    }
  >
    {eventsData?.map((data) => (
      <TableBodyCustom key={data?._id} data={data} onEditRow={onEditRow} />
    ))}
  </DataTable>
);

export default TableView;
